export interface CaseStudy {
  id: number;
  title: string;
  profile: string;
  goal: string;
  stages: string[];
  beforeItems: string[];
  afterItems: string[];
  outcomeText: string;
}

export const caseStudies: CaseStudy[] = [
  {
    id: 1,
    title: 'Beginner Efficiency Improvement',
    profile: 'First-time spreadsheet user',
    goal: 'Improve product organization and reduce manual tracking errors',
    stages: ['Product Tracking', 'Decision Speed', 'Error Rate'],
    beforeItems: ['Scattered notes across multiple apps', 'Slow decision-making process', 'High error rate from manual entry'],
    afterItems: ['Structured rows and columns in one place', 'Faster side-by-side comparison', 'Reduced errors via structured format'],
    outcomeText: 'Using a Mulebuy spreadsheet system helped standardize the workflow and reduce decision delays significantly.',
  },
  {
    id: 2,
    title: 'Scaling Product Management',
    profile: 'Advanced user handling multiple items',
    goal: 'Manage large-volume spreadsheet data efficiently',
    stages: ['Scalability', 'Organization', 'Monitoring'],
    beforeItems: ['Limited scalability with manual methods', 'Low organization across scattered files', 'Difficult monitoring of inventory'],
    afterItems: ['High scalability with centralized system', 'Structured categorization by type', 'Centralized monitoring dashboard approach'],
    outcomeText: 'The Mulebuy spreadsheet model improves scalability by centralizing data handling and enabling bulk operations.',
  },
  {
    id: 3,
    title: 'Comparison Optimization Workflow',
    profile: 'Intermediate user comparing suppliers',
    goal: 'Optimize product comparison and supplier selection',
    stages: ['Price Analysis', 'Risk Assessment', 'Supplier Tracking'],
    beforeItems: ['Price comparison took hours', 'No risk scoring system', 'Supplier tracking was inconsistent'],
    afterItems: ['Side-by-side price comparison tables', 'Built-in risk scoring columns', 'Consistent supplier tracking format'],
    outcomeText: 'Combining multiple data points inside a Mulebuy spreadsheet creates a powerful decision-making engine for sourcing.',
  },
];